import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M24 17.483c0-1.796-1.319-3.261-3-3.447V11.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-2.537c1.681-.183 3-1.64 3-3.48zM20 23h-9V12h9v11zm1-3.027V15.03c1.115.186 2 1.239 2 2.519 0 1.226-.869 2.247-2 2.424zM15.5 10a.5.5 0 0 0 .5-.5c0-1.052.448-1.5 1.5-1.5C19.142 8 20 6.239 20 4.5a.5.5 0 0 0-1 0c0 1.242-.516 2.5-1.5 2.5-1.589 0-2.5.911-2.5 2.5a.5.5 0 0 0 .5.5z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;